import { horseAPI, productAPI, schoolAPI, transportAPI, stableAPI, trainerAPI, eventAPI, vetAPI } from '@/services/api';

export function resolveUrl(adType) {
	if (!adType) {
		return '';
	}
	if (adType === 'horse') {
		return 'horses'
	}
	if (adType === 'product') {
		return 'products';
	}
	if (adType === 'transport') {
		return 'transports';
	}
	if (adType === 'school') {
		return 'schools';
	}
	if (adType === 'stable') {
		return 'stables';
	}
	if (adType === 'trainer') {
		return 'trainers';
	}
	if (adType === 'event') {
		return 'events';
	}
	if (adType === 'vet') {
		return 'vets';
	}

	return '';
}

export function resolveApi(adType) {
	if (!adType) {
		return null;
	}

	if (adType === 'horse') {
		return horseAPI;
	}
	if (adType === 'product') {
		return productAPI;
	}
	if (adType === 'transport') {
		return transportAPI
	}
	if (adType === 'school') {
		return schoolAPI;
	}
	if (adType === 'stable') {
		return stableAPI;
	}
	if (adType === 'trainer') {
		return trainerAPI;
	}
	if (adType === 'event') {
		return eventAPI;
	}
	if (adType === 'vet') {
		return vetAPI;
	}
	return null;
}

export function resolveTab(tab) {
	if (!tab) {
		return 'horse';
	}

	return tab;
}

export function resolveSearchType(adType) {
	if (adType === 'horse') {
		return 'savedSearch.type_horse';
	}
	if (adType === 'product') {
		return 'savedSearch.type_product';
	}
	if (adType === 'transport') {
		return 'savedSearch.type_transport';
	}
	if (adType === 'school') {
		return 'savedSearch.type_riding_school';
	}
	if (adType === 'stable') {
		return 'savedSearch.type_stable';
	}
	if (adType === 'trainer') {
		return 'savedSearch.type_trainer';
	}
	if (adType === 'event') {
		return 'savedSearch.type_event';
	}
	if (adType === 'vet') {
		return 'savedSearch.type_vet';
	}
	return 'savedSearch.type_all';
}

export function resolveLabel(adType) {
	if (!adType) {
		return null;
	}

	if (adType === 'horse') {
		return 'nav.horses';
	}
	if (adType === 'product') {
		return 'nav.products';
	}
	if (adType === 'transport') {
		return 'nav.transports';
	}
	if (adType === 'school') {
		return 'nav.schools';
	}
	if (adType === 'stable') {
		return 'nav.stables';
	}
	if (adType === 'trainer') {
		return 'nav.trainers';
	}
	if (adType === 'event') {
		return 'nav.events';
	}
	if (adType === 'vet') {
		return 'nav.vets';
	}

	return null;
}

export function resolveSearchTab(adType, totals, t) {
	if (adType === 'all') {
		return `${t('common.all')} (${totals.total})`;
	}
	if (adType === 'horse') {
		return `${t('nav.horses')} (${totals.horse_total})`;
	}
	if (adType === 'product') {
		return `${t('nav.products')} (${totals.product_total})`;
	}
	if (adType === 'transport') {
		return `${t('nav.transports')} (${totals.transport_total})`;
	}
	if (adType === 'school') {
		return `${t('nav.schools')} (${totals.school_total})`;
	}
	if (adType === 'stable') {
		return `${t('nav.stables')} (${totals.stable_total})`;
	}
	if (adType === 'trainer') {
		return `${t('nav.trainers')} (${totals.trainer_total})`;
	}
	if (adType === 'event') {
		return `${t('nav.events')} (${totals.event_total})`;
	}
	if (adType === 'vet') {
		return `${t('nav.vets')} (${totals.vet_total})`;
	}
	return '';
}

export function injectAds(listings, page) {
	const withAds = [];
	const idx = (page - 1) * 12;
	withAds.push({ type: 'ad', id: `ad-${idx}` });
	listings.forEach(listing => {
		withAds.push({...listing, type: 'listing' });
	});
	return withAds;
}